// extracted by mini-css-extract-plugin
export default {"wrap":"c733a9176cac","ruleIssueCount":"da68cf2afe30"};